import { AppData, Router } from '@lightningjs/sdk';
import Page from 'components/Page';
import { PageId } from 'types/pageId';

export default class LoginPage extends Page {
  protected override _pageId = PageId.LOGIN;

  override _active() {
    super._active();
    AppData?.modalService.open('LoginLanding');
  }

  onLoginExit() {
    const currentTime = new Date().getTime();
    AppData?.storageService.loginRegistrationShownTimestamp.set(currentTime);

    const loginTarget = AppData?.device.getSessionStorage<{
      path: string;
      params?: Router.PageParams;
    }>('deepLinkAfterLogin');

    if (loginTarget?.path) {
      AppData?.device.handleDeepLinkURL(loginTarget.path, loginTarget.params);
      AppData?.device.removeSessionStorage('deepLinkAfterLogin');
    } else {
      Router.back();
    }
  }
}
